import {
  Flexbox,
  Form, LoadManager, PageHeader, Styles,
} from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import params from '@/services/api/params'
import React, { useCallback, useMemo, useState } from 'react'
import { toast } from 'react-toastify'
import DocumentFormAdd from '../components/DocumentFormAdd'
import DocumentRow from '../components/DocumentRow'

function Protectors({ title }) {
  usePageTitle({ title })

  const [updating, setUpdating] = useState(false)
  const {
    loading, data, setData, error,
  } = useAxiosRequest(params.list)

  const documents = useMemo(() => (
    data?.licensingDocuments?.protector || []
  ), [data?.licensingDocuments?.protector])

  const onAdded = useCallback(async (document) => {
    try {
      setUpdating(true)
      const protector = [...documents, { ...document, id: Date.now() }]
      const body = {
        ...data,
        licensingDocuments: { ...(data.licensingDocuments || {}), protector },
      }

      await params.update(body)
      setData(body)

      toast.success('Documento adicionado com sucesso')
    } catch (e) {
      toast.error(e?.message)
    } finally {
      setUpdating(false)
    }
  }, [data, documents, setData])

  const onUpdated = useCallback(async (document) => {
    try {
      setUpdating(true)
      const protector = documents.map((i) => (i.id === document.id ? document : i))
      const body = {
        ...data,
        licensingDocuments: { ...(data.licensingDocuments || {}), protector },
      }

      await params.update(body)
      setData(body)

      toast.success('Documento atualizado com sucesso')
    } catch (e) {
      toast.error(e?.message)
    } finally {
      setUpdating(false)
    }
  }, [data, documents, setData])

  const onRemoved = useCallback(async (document) => {
    try {
      setUpdating(true)
      const protector = documents.filter((i) => i.id !== document.id)
      const body = {
        ...data,
        licensingDocuments: { ...(data.licensingDocuments || {}), protector },
      }
      await params.update(body)
      setData(body)

      toast.success('Documento removido com sucesso')
    } catch (e) {
      toast.error(e?.message)
    } finally {
      setUpdating(false)
    }
  }, [data, documents, setData])

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title="Parâmetros para protetores"
        icon="fas fa-hand-holding-heart"
        subtitle="Definir os parâmetros para os protetores e protetoras independentes"
      />
      <LoadManager loading={loading || updating} error={error}>
        <Flexbox.Columns>
          <Flexbox.Column className="col-8 col-sm-12">
            <Form.Group>
              <Form.Label>
                Documentos exigidos para os protetores solicitarem credenciamento
              </Form.Label>
              {
                documents.length
                  ? (
                    documents.map((document) => (
                      <DocumentRow
                        key={document.id}
                        document={document}
                        onUpdated={onUpdated}
                        onRemoved={onRemoved}
                      />
                    ))
                  )
                  : <small><cite>Nenhum documento é exigido</cite></small>
              }
            </Form.Group>
          </Flexbox.Column>
        </Flexbox.Columns>
        <DocumentFormAdd onAdded={onAdded} />
      </LoadManager>
    </Styles.Container>
  )
}

export default Protectors
